export default __webpack_public_path__ + "static/media/practicum-logo.29786687.svg";